import { UseQueryResult } from 'react-query/types/react/types';
import { useQuery } from 'react-query';
import { QueryKey } from 'src/models/query';
import { useAPIs } from 'src/hooks/useAPIs';
import { APIs } from 'src/models/apis';
import {
  ShowcaseSection,
  ShowcaseSectionData,
} from 'src/modules/materials/models/showcase';

export const fetchVideosShowcaseSections = async (
  apis: APIs,
): Promise<ShowcaseSectionData[]> => {
  const user = await apis.cachedKratosSession();

  return [
    {
      name: 'Recently added',
      variables: {
        filters: { status: { _eq: 'published' }, showcase: { _eq: true } },
        sort: ['-date_created'],
        limit: 10,
        itemsToQuery: ['videos'],
      },
      type: ShowcaseSection.List,
      searchQuery: { recent: 'true' },
    },
    {
      name: 'Injection techniques',
      searchQuery: { subject: 'injection-techniques' },
      taxonomy: {
        subject: 'injection-techniques',
      },
      variables: {
        sort: ['-date_created'],
        filters: {
          showcase: { _eq: true },
          status: {
            _eq: 'published',
          },
          subjects: {
            subjects_id: {
              slug: {
                _eq: 'injection-techniques',
              },
            },
          },
        },
        limit: 10,
        itemsToQuery: ['videos'],
      },
      type: ShowcaseSection.List,
    },
    {
      name: 'Trending now',
      variables: {
        sort: ['-date_created'],
        filters: {
          showcase: { _eq: true },
          status: { _eq: 'published' },
          trendingNow: { _eq: true },
        },
        limit: 5,
        itemsToQuery: ['videos'],
      },
      type: ShowcaseSection.HeroList,
    },
    ...((user
      ? [
          {
            name: 'My favorites',
            type: ShowcaseSection.Favorites,
            searchQuery: { favourites: 'true' },
          },
        ]
      : []) as ShowcaseSectionData[]),
    {
      name: 'Protocol treatment',
      type: ShowcaseSection.ProtocolTreatment,
    },
    {
      name: 'Experts talks',
      type: ShowcaseSection.BusinessCases,
    },
    {
      name: 'events',
      searchQuery: { subject: 'events' },
      variables: {
        sort: ['-date_created'],
        filters: {
          showcase: { _eq: true },
          status: { _eq: 'published' },
          subjects: {
            subjects_id: {
              slug: {
                _eq: 'events',
              },
            },
          },
        },
        limit: 10,
        itemsToQuery: ['videos'],
      },
      type: ShowcaseSection.List,
    },
  ];
};

export const useVideosShowcaseSectionsQuery = (): UseQueryResult<
  ShowcaseSectionData[]
> => {
  const apis = useAPIs();
  return useQuery(QueryKey.VideoFilterSections, () =>
    fetchVideosShowcaseSections(apis),
  );
};
